<template>
	<input
		class="roundup-input2"
		:class="[type ? 'input-type--' + type : '']"
		v-bind:value="value"
		v-on:input="$emit('input', $event.target.value)"
		:type="nativeType"
	/>
</template>

<script>
export default {
	name: 'roundup-input',
	props: ['value', 'type', 'nativeType']
}
</script>

<style lang="scss">
.roundup-input2 {
	background: $input-grey;
	border-width: 0px;
	width: 100%;
	font-size: $font-size;
	padding: 20px 15px;
	outline: none;
	-webkit-appearance: none;
	appearance: none;
	border-radius: 10px;
	&:hover {
		background: $light-grey;
	}
	&.input-type--blue {
		color: $white;
		background: $navy-highlight;
		caret-color: $white;
		&::placeholder {
			color: $medium-grey;
		}
		&::-webkit-input-placeholder {
			color: $medium-grey;
		}
		&::-moz-placeholder {
			color: $medium-grey;
		}
	}
	&.input-type--white {
		color: $charcoal;
		background: $white;
		caret-color: $navy;
		border: 1px solid $slate;
		&::placeholder {
			color: $slate;
		}
		&::-webkit-input-placeholder {
			color: $slate;
		}
		&::-moz-placeholder {
			color: $slate;
		}
	}
}
</style>
